<mat-form-field appearance="outline" class="full-width">
  <mat-label>{{ label }}</mat-label>
  <input matInput
         [matDatepicker]="picker"
         [formControl]="dateControl"
         [required]="required"
         [min]="min"
         [max]="max"
         [placeholder]="placeholder"
         (blur)="onTouched()">
  <mat-datepicker-toggle matIconSuffix [for]="picker" [disabled]="dateControl.disabled"></mat-datepicker-toggle>
  <mat-datepicker #picker [disabled]="dateControl.disabled"></mat-datepicker>
  @if (showError()) {
    <mat-error>{{ currentErrorMessage() }}</mat-error>
  }
</mat-form-field>
